import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import {
  Button,
  Grid,
  Theme,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';

import { ExclamationCircleIcon } from '../../components/icon/solid';
import { Link, PagesTitle } from '../../components';
import { useQuery, useTitle } from '../../hooks';
import { Links } from '../../utility/links';
import PageContainer from './PageContainer';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    height: '64px',
    width: '64px',
    color: palette.error.main,
  },
  title: {
    marginTop: '56px',
    marginBottom: '24px',
  },
  error: {
    fontWeight: 600,
  },
  body: {
    color: palette.text.secondary,
    textAlign: 'center',
    fontSize: '16px',
    paddingBottom: '16px',

    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  },
  button: {
    borderRadius: '5px',
    borderWidth: '1.5px',
    minWidth: '170px',

    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    margin: '42px 12px 42px 12px',
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  support: {
    color: palette.menuAction.selected,
    borderColor: palette.menuAction.selected,
  },
}), { name: 'EmailConfirmationError' });

const EmailConfirmationError = () => {
  const classes = useStyles();

  useTitle('Error');

  const { error = 'an unexpected error occurred.' } = useQuery<{ error: string }>();

  return (
    <PageContainer>
      <Grid container className={classes.root}>
        <ExclamationCircleIcon className={classes.icon} />
        <PagesTitle className={classes.title}>Confirmation Error</PagesTitle>
        <Typography variant="body1" component="div" className={classes.body}>
          <p>Your email address has been confirmed, however</p>
          <p className={classes.error}>{error}</p>
        </Typography>
        <Typography variant="body1" component="div" className={classes.body}>
          <p>Please contact customer support if you are not sure</p>
          <p>why this error occurred.</p>
        </Typography>
        <Link to={Links.support} defaultAction target="_blank" className={classes.buttonLink}>
          <Button
            variant="outlined"
            className={clsx(classes.button, classes.support)}
          >
              Customer Support
          </Button>
        </Link>
      </Grid>
    </PageContainer>
  );
};

export default EmailConfirmationError;
